import { PiPencilSimpleLine } from 'react-icons/pi'
import SuggestionModal from 'components/Modals/SuggestionModal/SuggestionModal'

interface CompanySidebarFooterProps {
  chainProxyId: number
  companyName: string
  domain: string
  doorId?: number
  address?: string
  phone?: string
}

export function CompanySidebarFooter({
  chainProxyId,
  companyName,
  domain,
  doorId,
  address,
  phone,
}: CompanySidebarFooterProps) {
  return (
    <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 mt-auto flex justify-center">
      <SuggestionModal
        contactCompanyId={chainProxyId}
        doorId={doorId}
        tableTypeSlug="restaurants-bars"
        defaultValues={{
          suggested_name: companyName,
          suggested_website: domain,
          ...(doorId && {
            suggested_address: address,
            suggested_phone_number: phone,
          }),
        }}
      >
        <button className="flex items-center gap-1 text-brand-active hover:text-brand transition-colors bg-transparent border-none p-0 cursor-pointer">
          <PiPencilSimpleLine size={16} />
          <span className="text-sm font-medium leading-[1.0431597573416573em]">
            Suggest an edit
          </span>
        </button>
      </SuggestionModal>
    </div>
  )
}
